export var StickyPositionType;
(function (StickyPositionType) {
  StickyPositionType[StickyPositionType["Both"] = 0] = "Both";
  StickyPositionType[StickyPositionType["Header"] = 1] = "Header";
  StickyPositionType[StickyPositionType["Footer"] = 2] = "Footer";
})(StickyPositionType || (StickyPositionType = {}));